module.exports = __webpack_public_path__ + "img/startimes.478c9c84.jpg";